import { createUseStyles } from 'react-jss'
import style from './style'
import { TypographyElement, Button, Icon, Icons } from 'UI'
import Text from './text.json'
import { paymentStep } from '../UI'
import { formatDateDMY } from 'helpers'

const useStyles = createUseStyles(style)

export default ({ setStep, reactivateSubscription, contactEmail, contactPhone, subscriptionEndDate, setOpen }) => {
  const { mainIcon, checkIcon, controlContainer } = useStyles()
  return (
    <div>
      <Icon iconName={Icons.check} style={mainIcon} />
      <TypographyElement variant='heading1' spacing='0 0 16px 0'>
        {Text.title}
      </TypographyElement>
      <TypographyElement variant='body1' spacing='0 0 8px 0'>
        {Text.subTitle}
      </TypographyElement>
      <TypographyElement variant='body1' spacing='0 0 8px 0'>
        <Icon iconName={Icons.check} style={checkIcon} />
        {`${Text.confirmList1} ${formatDateDMY(subscriptionEndDate)}`}
      </TypographyElement>
      <TypographyElement variant='body1' spacing='0 0 24px 0'>
        <Icon iconName={Icons.check} style={checkIcon} />
        {Text.confirmList2}
      </TypographyElement>
      <TypographyElement variant='body2'>
        {Text.cancelConfirmation}
      </TypographyElement>
      <TypographyElement variant='body2' spacing='0 0 32px 0'>
        {`${Text.contact} ${contactEmail} ${Text.call} ${contactPhone}`}
      </TypographyElement>
      <div className={controlContainer}>
        <Button
          variation='primary'
          size='small'
          label={Text.continue}
          onHandleClick={() => {
            reactivateSubscription()
            setOpen(false)
            setStep(paymentStep)
          }}
          width={174}
          widthTablet='100%'
          widthMobile='100%'
          marginButton='0 16px 0 0'
        />
        <Button
          dataTest='disable-account-modal-button'
          variation='text'
          size='small'
          label={Text.goback}
          onHandleClick={() => { setStep(paymentStep) }}
          width={174}
          widthTablet='100%'
          widthMobile='100%'
        />
      </div>
    </div>
  )
}
